export default __webpack_public_path__ + "static/media/bojo_l.def27103.jpg";